function commuitylider() {
 $('.commuitylider').slick({
  centerMode: true,
  centerPadding: '150px',
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 750,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '0px',
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        centerPadding: '0px',
        arrows: false
      }
    }
  ]
});
}
commuitylider();
document.addEventListener("shopify:section:load", commuitylider);
 $('.programs-container').slick({
  dots: true,
  arrows: false,
  infinite: false,
  slidesToShow: 2.5,
  adaptiveHeight: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
 $('.success-container').slick({
  dots: true,
  arrows: false,
  slidesToShow: 1.3,
  infinite: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$(document).on('click', '.new_image_with_text .niwt_button_container .btnprimary', function(){
  $("html, body").animate({
      scrollTop: $('.programs-slider-sec').offset().top
    }, 700);
});
